// extracted by mini-css-extract-plugin
export default {"nsp_pay_detail":"NSPPayDetail_nsp_pay_detail__T2YEp","nsp_right_row":"NSPPayDetail_nsp_right_row__HqfTB"};